<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
          <div class="card-title">
              <h5 style="text-align: start">{{ title }}</h5>
          </div>
          <div class="card-toolbar">
              <ButtonDropdownFilter
                  :btn-title="$t('crm.label.owner')"
                  :options="salesPersons"
                  value-field="id"
                  name-field="fullname"
                  v-model="query.seller_id"
                  :border="true"
              />
          </div>   
        </div>
        <Loader :is-loading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <div v-show="!opportunitiesEstimateStats?.length" class="text-center">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            </div>
            <div v-show="opportunitiesEstimateStats?.length" class="p-5">
              <div class="row">
                <div class="col-12 col-md-7 col-lg-7 d-flex justify-content-center align-items-center position-relative">
                  <canvas id="kt_chartjs_estimate_generate_opportunity" class="mh-400px"></canvas>
                  <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; height: 50%; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                    <div class="text-center">
                      <h1 class="display-2">{{getStatusData('APPROVED')?.count + getStatusData('PENDING')?.count}}</h1>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4 d-flex justify-content-center align-items-center">
                  <div class="p-5" style="border: 2px solid #CCCFD3; border-radius: 8px; width: 100%;">
                    <div class="d-flex mb-15">
                      <span class="px-20 py-5 me-2" style="border-radius: 5px; background-color: #0072CE66;"></span>
                      <span class="mt-2">{{ $t('estimate.total_estimate') }}: <span class="fw-bold">{{getStatusData('PENDING')?.count}}</span></span>
                    </div>
                    <div class="d-flex mb-5">
                      <span class="bg-primary px-20 py-5 me-2" style="border-radius: 5px;"></span>
                      <span class="mt-2">{{ $t('estimate.estimate_validate') }}: <span class="fw-bold">{{getStatusData('APPROVED')?.count}}</span></span>
                    </div>
                    <div class="row text-start fw-bold fs-3">
                      <div v-html="formattedEstimatePercent"></div>
                      <div>{{ $t('estimate.estimation') }}: <span class="text-primary">{{ $formatLocalAmount(getEstimationStatus.total) }} {{ defaultCurrency?.symbol }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import ButtonDropdownFilter from '@/components/ButtonDropdownFilter.vue';
import Loader from '@/components/Loader.vue';
import {$formatLocalAmount} from "@/mixins/Helpers";
import { computed } from 'vue';
import { watch } from 'vue';
import {  shallowRef,onMounted, ref} from 'vue';
import { useStore } from 'vuex';

const store = useStore()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})
  
const query = ref({
    start_date: '',
    end_date: '',
    seller_id: '',
})

const opportunitiesEstimateStats = ref([])
const chartPipelineRef = shallowRef(null)


const salesPersons = computed(() => store.getters['pipelines/getSalesPersons'])
const estimateStatus = computed(() => store.getters['estimates/estimateStatus'])

const getEstimationStatus = computed(() => {
    let validate = getStatusData('APPROVED')?.count
    let pending = getStatusData('PENDING')?.count
    let percent = validate*100/(validate+pending)

    return {percent: percent.toFixed(2), total: getStatusData('APPROVED')?.amount}
  })

const formattedEstimatePercent = computed(() => {
  return i18n.global.t('estimate.estimate_validate_percent', { percent: getEstimationStatus.value.percent+'%' });
});

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})


function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  
    Promise.all([
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, seller_id: query.value.seller_id}).then((res) => {

        opportunitiesEstimateStats.value = res.data?.opportunitiesEstimateStats || res?.response?.opportunitiesEstimateStats

        }),
        store.dispatch('pipelines/loadSalesPersons'),
        store.dispatch('estimates/loadEstimateStatus'),


    ]).then(() => {
      chartPipeline()
    })
}

function filterStatus(value){
    let statistic = estimateStatus.value.filter(status => status.value === value)
    return statistic
  }

function getStatusData(value){
  let data = opportunitiesEstimateStats.value?.filter(item => item.name == value)[0]
  return data
}

function chartPipeline(){
    let names = [];
    let percentages = [];

    opportunitiesEstimateStats.value?.forEach(status => {
      let filter = filterStatus(status.name)[0]
      if (status.percentage > 0) { 
        names.push(filter[locale.value])
        percentages.push(status.percentage)
      }
    })

    if(names.length === 0 || percentages.length === 0){
      opportunitiesEstimateStats.value = [];
    }

    let ctx = document.getElementById('kt_chartjs_estimate_generate_opportunity');

    if (ctx) {
      if(Chart.getChart("kt_chartjs_estimate_generate_opportunity")) {
        Chart.getChart("kt_chartjs_estimate_generate_opportunity")?.destroy()
      }

      let context = ctx.getContext('2d');
      let fontFamily = KTUtil.getCssVariableValue('--bs-font-sans-serif');

      let data = {
          labels: names,
          datasets: [{
            data: percentages,
            backgroundColor: ['#0072CE', '#0072CE66'],
            hoverOffset: 10
        }]
      };

      let config = {
          type: 'doughnut',
          data: data,
          options: { 
            plugins: {
                legend: {
                    display: true,
                    position: 'bottom'
                },
                tooltip: {
                    callbacks: {
                        label: function(context) {
                          let percentageLabel = i18n.global.t('crm.statistics.percentage');
                            return `${percentageLabel}: ${$formatLocalAmount(context.parsed)} %`;
                        }
                    }
                },
                centerText: {
                  display: true,
                  text: '15'
                }
            },
            responsive: true,
            elements: {
              arc: {
                  borderWidth: 1 
              }
            },
            cutout: '80%'
          },
          defaults:{
              global: {
                  defaultFont: fontFamily
              }
          }
      };

      if (!chartPipelineRef.value) {
        chartPipelineRef.value = new Chart(ctx, config);
      }else{
        chartPipelineRef.value.destroy()
        chartPipelineRef.value = new Chart(ctx, config);
      }
    } else {
      console.error('Canvas element not found');
      return;
    }
  }
  
onMounted(() => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})
</script>